import { RestClient } from '../restClient';
import {
  IAccountActionRs,
  IAddAccountRequest,
  IChangeAccountRequest,
  IDeleteAccountRequest,
  ILoginRequest,
  ITokenRs,
  TAuthType,
} from './models';
import { AUTH_TYPE_EDGE, AUTHORIZING_URL } from './consts';

/**
 * Класс для работы с авторизацией
 * Универсален для любой среды запроса:
 *  - NODE (getServerSideProps, getInitialProps и т.д.),
 *  - браузере,
 *  - edge runtime (middleware у nextjs)
 *
 * В обычных случаях мы не должны его использовать
 * Используй NgApiClient или ServerNgApiClient
 *
 * !!!!!ATTENTION!!!!!!
 * Класс позволяет работать в middleware проектов nextjs (среда Edge Runtime, !!!среда где не функционирует axios без специальных адаптеров)
 * Поэтому в таком случае используется нативный метод fetch, т.к. нормальных адаптеров для axios (для версии 1 и выше) на текущий момент не было.
 * !!!!!ATTENTION!!!!!
 *
 * TODO: Предполагается, что класс не будет дальше развиваться, поэтому методы не оптимизированны.
 * Если появится необходимость для развития класса, необходимо провести рефакторинг и накинуть тестирование
 */
export class AuthClient {
  private type?: TAuthType;

  private baseUrl: string;

  private fetchConfig = {
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
  };

  constructor(config: { baseUrl: string; type?: TAuthType }) {
    this.baseUrl = config.baseUrl;
    this.type = config.type;
  }

  /** метод перезапроса токена */
  public authorizing = async (refreshToken: string): Promise<IAccountActionRs> => {
    if (typeof refreshToken !== 'string') return Promise.reject(undefined);

    if (this.type === AUTH_TYPE_EDGE) {
      const body = JSON.stringify({ refreshToken });

      return await fetch(`${this.baseUrl}${AUTHORIZING_URL}`, {
        ...this.fetchConfig,
        body,
        method: 'PUT',
      }).then((res) => res.json());
    }

    const result = await new RestClient({ baseURL: this.baseUrl }).put<{ refreshToken: string }, IAccountActionRs>(
      AUTHORIZING_URL,
      {
        refreshToken,
      },
    );
    return result.data;
  };

  /** метод логина */
  public login = async (requestData: ILoginRequest): Promise<ITokenRs> => {
    if (this.type === AUTH_TYPE_EDGE) {
      const body = JSON.stringify(requestData);

      return await fetch(`${this.baseUrl}${AUTHORIZING_URL}`, {
        ...this.fetchConfig,
        body,
        method: 'POST',
      }).then((res) => res.json());
    }

    const result = await new RestClient({ baseURL: this.baseUrl }).post<ILoginRequest, ITokenRs>(
      AUTHORIZING_URL,
      requestData,
    );

    return result.data;
  };

  /** метод добавления еще одного аккаунта  */
  public async addAccount(refreshToken: string, addLinkedUserRefreshToken: string): Promise<ITokenRs> {
    const data: IAddAccountRequest = {
      refreshToken,
      addLinkedUserRefreshToken,
    };

    if (this.type === AUTH_TYPE_EDGE) {
      const body = JSON.stringify(data);

      return await fetch(`${this.baseUrl}${AUTHORIZING_URL}`, {
        ...this.fetchConfig,
        body,
        method: 'PUT',
      }).then((res) => res.json());
    }

    const result = await new RestClient({ baseURL: this.baseUrl }).put<IAddAccountRequest, ITokenRs>(
      AUTHORIZING_URL,
      data,
    );

    return result.data;
  }

  public async changeAccount(refreshToken: string, targetUserId: number): Promise<IAccountActionRs> {
    const data: IChangeAccountRequest = {
      refreshToken,
      targetUserId,
    };

    if (this.type === AUTH_TYPE_EDGE) {
      const body = JSON.stringify(data);

      return await fetch(`${this.baseUrl}${AUTHORIZING_URL}`, {
        ...this.fetchConfig,
        body,
        method: 'PUT',
      }).then((res) => res.json());
    }

    const result = await new RestClient({ baseURL: this.baseUrl }).put<IChangeAccountRequest, IAccountActionRs>(
      AUTHORIZING_URL,
      data,
    );

    return result.data;
  }

  public async deleteAccount(refreshToken: string, removeLinkedUserId: number): Promise<ITokenRs> {
    const data: IDeleteAccountRequest = {
      refreshToken,
      removeLinkedUserId,
    };

    if (this.type === AUTH_TYPE_EDGE) {
      const body = JSON.stringify(data);

      return await fetch(`${this.baseUrl}${AUTHORIZING_URL}`, {
        ...this.fetchConfig,
        body,
        method: 'PUT',
      }).then((res) => res.json());
    }

    const result = await new RestClient({ baseURL: this.baseUrl }).put<IDeleteAccountRequest, ITokenRs>(
      AUTHORIZING_URL,
      data,
    );

    return result.data;
  }
}
